import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { ComposerMode } from '../types/index';
import { EventSeriesOption, } from './useEvent/useEventTypes';
import { buildUpdateEventPayload, shouldUpdateAsSpace, } from '../utils/payloadBuilders';
import { getRecurrenceKey } from '../components/RecurrenceDropdown/utils';
export var useHandleEventUpdate = function (_a) {
    var formData = _a.formData, timezone = _a.timezone, initialEvent = _a.initialEvent, calendarType = _a.calendarType, calendarMailboxAddress = _a.calendarMailboxAddress, updateEvent = _a.updateEvent, setRecurringEventToUpdate = _a.setRecurringEventToUpdate, onError = _a.onError, onClose = _a.onClose, onSubmit = _a.onSubmit;
    var t = useTranslation('meetingRooms').t;
    var handleEventUpdate = useCallback(function () {
        if (!(formData === null || formData === void 0 ? void 0 : formData.eventId)) {
            onError(new Error(t('update_event.no_event_id_found')));
            return;
        }
        var updatedEvent = buildUpdateEventPayload({
            formData: formData,
            timezone: timezone,
            calendarType: calendarType,
            calendarMailboxAddress: calendarMailboxAddress,
        });
        var recurrenceValueChanged = getRecurrenceKey(initialEvent === null || initialEvent === void 0 ? void 0 : initialEvent.recurrenceRule) !==
            getRecurrenceKey(updatedEvent === null || updatedEvent === void 0 ? void 0 : updatedEvent.recurrence);
        if (updatedEvent) {
            var updateAsSpace = shouldUpdateAsSpace(initialEvent === null || initialEvent === void 0 ? void 0 : initialEvent.eventPermissions);
            if ((initialEvent === null || initialEvent === void 0 ? void 0 : initialEvent.seriesId) && !recurrenceValueChanged) {
                setRecurringEventToUpdate(updatedEvent);
            }
            else {
                updateEvent(updatedEvent, formData.eventId, timezone, recurrenceValueChanged
                    ? EventSeriesOption.ALL_EVENTS
                    : EventSeriesOption.THIS_EVENT, updateAsSpace, recurrenceValueChanged)
                    .then(function (res) {
                    if (!res) {
                        onError(new Error('No response from updateEvent'));
                        onClose();
                        return;
                    }
                    onSubmit(res.data, ComposerMode.EDIT);
                    onClose();
                })
                    .catch(function () {
                    // updateEvent already calls onError before re-throwing; swallow to avoid unhandled rejection
                });
            }
        }
    }, [
        formData,
        timezone,
        initialEvent,
        calendarType,
        calendarMailboxAddress,
        updateEvent,
        setRecurringEventToUpdate,
        onError,
        onClose,
        onSubmit,
        t,
    ]);
    return { handleEventUpdate: handleEventUpdate };
};
